import { ICountry } from '@core/data-access';
import { AddressSubType, AddressType } from '../type';

export type LocalAddress = {
  postalCode: string;
  blockNumber: string;
  streetName: string;
  buildingName: string;
  storey: string;
  unitNumber: string;
};

export type ForeignAddress = {
  addressLine1: string;
  addressLine2: string;
  countryId: number;
};

export interface IAddress {
  id?: number | null;
  type: AddressType;
  subType: AddressSubType;
  postalCode: string;
  blockNumber: string;
  streetName: string;
  buildingName: string;
  storey: string;
  unitNumber: string;
  addressLine1: string;
  addressLine2: string;
  countryId?: number;
  country?: ICountry;
  attrs?: Record<string, any>;
}
